<div class="no-results-container">
  <div>
    <span class="page-title">Empty Scootaverse</span>
  </div>
  <div>
    <span class="page-description">Please create a new room:</span>
  </div>
  <div>
    <app-home-button
      data-testid="create-room-button"
      variant="outlined"
      color="secondary"
      rounded="pill"
      (click)="createRoom()"
      >Create New Room</app-home-button
    >
  </div>
</div>
